import { DeviceRequest } from "../device.request";

import { TokenTwoFactorRequest } from "./token-two-factor.request";
import { TokenRequest } from "./token.request";

/**
 * Posts a Google-issued ID token to the identity endpoint via the "google" grant
 * type. No captcha, no password material — the backend verifies the ID token's
 * signature against Google's JWKS and find-or-creates the user from its claims.
 */
export class GoogleTokenRequest extends TokenRequest {
  constructor(
    public idToken: string,
    protected twoFactor: TokenTwoFactorRequest,
    device?: DeviceRequest,
  ) {
    super(twoFactor, device);
  }

  toIdentityToken(clientId: string) {
    const obj = super.toIdentityToken(clientId);

    obj.grant_type = "google";
    obj.id_token = this.idToken;

    return obj;
  }
}
